import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PagesComponent } from './pages/pages.component';
import { NopagefoundComponent } from './shared/nopagefound/nopagefound.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '', loadChildren: () => import('./pages/completado-registro/completado-registro.module').then(mod => mod.CompletadoRegistroModule) },
  { path: '', loadChildren: () => import('./pages/login/login.module').then(mod => mod.LoginModule)},
  {
    path: '',
    component: PagesComponent,
    loadChildren: () => import('./pages/pages.module').then(mod => mod.PagesModule)
  },
  { path: 'inicio', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', component: NopagefoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
